module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm4": "",
      "md1": "",
      "text-xs-right": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 100,
      "imaSrc": "design/gray-arrow",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md8": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Para determinar el valor de su patrimonio",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("Para determinar el"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("valor de su ")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" patrimonio")])], 2), _vm._v(" "), _c('p', {
    staticClass: "davi-curs"
  }, [_vm._v("debe tener en cuenta los siguientes componentes:")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Determinar su patrimonio',
      "videoEmbed": "ADMINISTRACIONDINERO46DeterminarPatrimonio.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeIn",
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('p', [_c('strong', [_vm._v("Haga clic sobre cada definición:")])])])], 1), _vm._v(" "), _c('ui-botsacronimos', {
    attrs: {
      "ordered": true,
      "bold": true,
      "bots": _vm.bots,
      "nombreLista": "Componentes"
    }
  }, _vm._l((_vm.bots), function(item, index) {
    return _c('div', {
      key: 'content' + index,
      staticClass: "animated fadeInRight",
      attrs: {
        "slot": 'cont-' + index
      },
      slot: 'cont-' + index
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.cont)
      }
    })])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ad8881d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-46.vue
// module id = 1018
// module chunks = 1